import React, { useState } from 'react';

import DesignerCalendar from './designerCalendar.jsx';
import JobCalendar from './jobCalendar.jsx';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ActionButton from '../shared/buttons/ActionButton.jsx';
import useCalendar from '../../utilities/useCalendar.jsx';
import formatter from '../../utilities/formatter.js';

const CalendarSwitcher = ({
    appointment,
    calendarView,
    newAppointment
}) => {
    const [view, setView] = useState(calendarView || 'Sales');
    const [item, setItem] = useState(appointment);
    const [saving, setSaving] = useState(false);
    const [confirmationAppt, setConfirmationAppt] = useState();
    const [selectedEvent, setSelectedEvent] = useState(appointment);
    const [alertMessage, setAlert] = useState({ warning: null, error: null });

    const confirm = (event) => {
        setConfirmationAppt(event);
    }

    const resourceUrl = view === "Sales" ? '/api/calendar/designerResources' : '/api/calendar/jobResources';
    const eventUrl = view === "Sales" ? '/api/calendar/designerCalendar' : '/api/calendar/jobCalendar';

    const cHandler = useCalendar(item, setItem,
        selectedEvent, setSelectedEvent, resourceUrl, eventUrl, newAppointment, setAlert, confirm, setSaving);

    return (
        <Row>
            <Col>
                {alertMessage.error &&
                    <Row className="row justify-content-center">
                        <Col>
                            <Alert variant="danger" onClose={() => setAlert({ ...alertMessage, error: null })} dismissible>{alertMessage.error}</Alert>
                        </Col>
                    </Row>
                }
                {alertMessage.warning &&
                    <Row className="row justify-content-center">
                        <Col>
                            <Alert variant="warning" onClose={() => setAlert({ ...alertMessage, warning: null })} dismissible>{alertMessage.warning}</Alert>
                        </Col>
                    </Row>
                }
                {item ?
                    (
                        <Row className="no-gutters">
                            <Col className="my-2 p-2" style={{ backgroundColor: '#d9eef0', borderTopLeftRadius: '7px', borderBottomLeftRadius: '7px' }}>
                                <strong>
                                    {`Scheduling for ${item.title}`}
                                </strong>
                            </Col>
                            <Col className="my-2 p-2 text-right" style={{ backgroundColor: '#d9eef0' }} >
                                {confirmationAppt &&
                                    <strong>{formatter.time(new Date(confirmationAppt.start))} - {formatter.time(new Date(confirmationAppt.end))}</strong>
                                }
                            </Col>
                            <Col xs={'auto'} className="my-2 p-2" style={{ backgroundColor: '#d9eef0', borderTopRightRadius: '7px', borderBottomRightRadius: '7px' }}>
                                {confirmationAppt &&
                                    <ActionButton
                                        imgSource="/images/check.svg"
                                        buttonText="Confirm"
                                        onClick={() => {
                                            setSaving(true);
                                            cHandler.postUpdate(confirmationAppt);
                                        }
                                        }
                                        disabled={saving}
                                    />
                                }
                                <ActionButton
                                    imgSource="/images/cancel.svg"
                                    buttonText="Cancel"
                                    onClick={() => {
                                        setItem();
                                        setSelectedEvent();
                                    }
                                    }
                                    disabled={saving}
                                />
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <Row className="justify-content-center">
                            <div className="p-3">
                                <ActionButton
                                    imgSource="/images/interaction_dark.svg"
                                    buttonText={<span style={{ textDecoration: (view === 'Sales' ? 'underline' : 'none') }}>Designer Calendar</span>}
                                    onClick={() => setView('Sales')}
                                />
                            </div>
                            <div className="p-3">
                                <ActionButton
                                    imgSource="/images/job_dark.svg"
                                    buttonText={<span style={{ textDecoration: (view === 'Job' ? 'underline' : 'none') }}>Job Calendar</span>}
                                    onClick={() => setView('Job')}
                                />
                            </div>
                        </Row>

                    )
                }
                <Row>
                    <Col>
                        {
                            {
                                'Sales': (
                                    <DesignerCalendar
                                        appointment={item}
                                        cHandler={cHandler}
                                        setAppointment={setItem}
                                        setSelectedEvent={setSelectedEvent}
                                    />
                                ),
                                'Service': (
                                    <JobCalendar
                                        appointment={item}
                                        cHandler={cHandler}
                                    />
                                ),
                                'Job': (
                                    <JobCalendar
                                        appointment={item}
                                        cHandler={cHandler}
                                    />
                                )
                            }[view]
                        }
                    </Col>
                </Row>
            </Col >
        </Row >
    );
}

export default CalendarSwitcher;